import React, { useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend'

import { Tag } from 'antd';

import { DraggableItemType } from '../../constants/dragItemType';

function getStyles(
  left,
  top,
  isDragging,
) {
  const transform = `translate3d(${left}px, ${top}px, 0)`
  return {
    position: 'relative',
    transform,
    WebkitTransform: transform,
    // IE fallback: hide the real node using CSS when dragging
    // because IE will ignore our custom "empty image" drag preview.
    opacity: isDragging ? 0 : 1,
    height: isDragging ? 0 : '',
  }
}

function DraggableAnswer(props) {
  const { value, left, top } = props;

  const [{isDragging}, drag, preview] = useDrag({
    item: {
      type: DraggableItemType.ANSWER,
      value, left, top
    },
    collect: monitor => ({
      isDragging: !!monitor.isDragging(),
    }),
  })

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true })
  }, [])

  return (
    <span ref={drag} style={getStyles(left, top, isDragging)}>
      <Tag
        color="green"
        style={{
          //opacity: isDragging ? 0.5 : 1,
          cursor: 'move',
        }}
      >
        <ReactMarkdown
          source={value.replace(/\*/g,'')}
          renderers={{
            paragraph: 'span'
          }}
        />
      </Tag>
    </span>
  );
}

export default DraggableAnswer;
